import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, AuthStatus, RequireAuth, RequireCapability } from './features/auth/AuthProvider';
import { LoginPage } from './features/auth/LoginPage';
import { HomeShell } from './features/shell/HomeShell';

const StatsWindow = lazy(() => import('./features/stats/StatsWindow'));
const StatsBoard = lazy(() => import('./features/stats/StatsBoard'));
const DisplayPage = lazy(() => import('./features/display/DisplayPage'));
const AvControlPage = lazy(() => import('./features/display/AvControlPage'));
const GuestPage = lazy(() => import('./features/guest/GuestPage'));
const PublicGuidePage = lazy(() => import('./features/public/PublicGuidePage'));
const PublicHighlightsPage = lazy(() => import('./features/public/PublicHighlightsPage'));

function AuthenticatedRoute({ capabilities, children }: { capabilities?: Array<'stats' | 'display' | 'av'>; children: React.ReactNode }) {
  return (
    <RequireAuth>
      {capabilities ? <RequireCapability anyOf={capabilities}>{children}</RequireCapability> : children}
    </RequireAuth>
  );
}

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route index element={<Navigate to="/login" replace />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="guest" element={<Suspense fallback={<AuthStatus message="Loading guest access" />}><GuestPage /></Suspense>} />
        <Route path="guide" element={<Suspense fallback={<AuthStatus message="Loading guide" />}><PublicGuidePage /></Suspense>} />
        <Route path="highlights" element={<Suspense fallback={<AuthStatus message="Loading highlights" />}><PublicHighlightsPage /></Suspense>} />
        <Route
          path="home"
          element={<AuthenticatedRoute><HomeShell /></AuthenticatedRoute>}
        />
        <Route path="stats/window" element={<AuthenticatedRoute capabilities={['stats', 'display']}><Suspense fallback={<AuthStatus message="Loading attendance" />}><StatsWindow /></Suspense></AuthenticatedRoute>} />
        <Route path="stats/board" element={<AuthenticatedRoute capabilities={['stats', 'display', 'av']}><Suspense fallback={<AuthStatus message="Loading display" />}><StatsBoard /></Suspense></AuthenticatedRoute>} />
        <Route path="display" element={<AuthenticatedRoute capabilities={['display', 'av']}><Suspense fallback={<AuthStatus message="Loading display" />}><DisplayPage /></Suspense></AuthenticatedRoute>} />
        <Route path="av" element={<AuthenticatedRoute capabilities={['av']}><Suspense fallback={<AuthStatus message="Loading AV controls" />}><AvControlPage /></Suspense></AuthenticatedRoute>} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </AuthProvider>
  );
}
